import React from 'react';

const PageHeader = ({ title, subtitle, actions = null }) => {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-gray-100 bg-gradient-to-br from-white via-white to-indigo-50/40 p-6 shadow-sm">
      <div className="absolute -top-10 -right-10 h-32 w-32 rounded-full bg-indigo-100 blur-3xl" />
      <div className="relative flex items-start justify-between">
        <div className="text-left">
          <h1 className="text-2xl font-extrabold tracking-tight bg-gradient-to-r from-gray-900 via-indigo-800 to-gray-700 bg-clip-text text-transparent">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-1 text-sm font-medium text-gray-600">{subtitle}</p>
          ) : null}
        </div>
        {actions ? <div className="flex items-center space-x-3">{actions}</div> : null}
      </div>
    </div>
  );
};

export default PageHeader;


